<template>
    <div class="select-place">
      <select v-model="meta">
        <option disabled value="">Wybierz metal</option>
        <option
          v-for="(alloy, index) in metalAlloys"
          :value="index+1" :key="index+1">
          {{ alloy.name }}
        </option>
      </select>
		<select
      v-if="meta != null"
      v-model="densityChoose"
      @change="denistyValue(densityChoose)"
    >
			<option disabled value="">Wybierz gęstość</option>
      <option
        v-for="(den, index) in densityArray[meta-1]"
        :value="den.value"
        :key="index">
        {{den.name}}
      </option>
		</select>
    </div>
</template>

<script>
export default {
  name: 'Selects',
  data() {
    return {
      metalAlloys: [
        { name: 'Brąz' },
        { name: 'Mosiądz' },
        { name: 'Miedź' },
        { name: 'Aluminium' },
        { name: 'Stal' },
        { name: 'Stopy Cu-Ni' },
        { name: 'CuA18/BA8' },
        { name: 'Ołów' },
        { name: 'Stopy ołowiu' },
        { name: 'Cynk' },
        { name: 'Stopy cynku' },
        { name: 'Złoto' },
      ],
      densityArray: [
        [{ name: '8,5 kg/dm3', value: '8.5' },
          { name: 'B2, B4, B8, B443 - 8,895 kg/dm3', value: '8.895' },
          { name: 'BA5 - 8,197 kg/dm3', value: '8.197' },
          { name: 'BA8 - 7,8 kg/dm3', value: '7.8' },
          { name: 'BA83 - 7,695 kg/dm3', value: '7.695' },
          { name: 'Bk1, Bk31 - 8,497 kg/dm3', value: '8.497' },
          { name: 'BB1,7 - 8,4 kg/dm3', value: '8.4' },
          { name: 'BB2 - 8,295 kg/dm3', value: '8.295' },
          { name: 'BB21, BC2 - 8,895 kg/dm3', value: '8.895' },
        ],
        [{ name: '8.5kg/dm3', value: '8.5' }],
        [{ name: '8.9kg/dm3', value: '8.9' }],
        [{ name: '2,7 kg/dm3', value: '2.7' },
          { name: 'EN AW-3103 2,749 kg/dm3', value: '2.749' },
          { name: 'EN AW-5251 2,678 kg/dm3', value: '2.678' },
          { name: 'EN AW-6101A 2,689 kg/dm3', value: '2.689' },
          { name: 'EN AW-6082 2,7 kg/dm3', value: '2.7' },
          { name: 'EN AW-5019 2,638 kg/dm3', value: '2.638' },
          { name: 'EN AW-6061 2,713 kg/dm3', value: '2.713' },
          { name: 'EN AW-2017A 2,799 kg/dm3', value: '2.799' },
          { name: 'EN AW-2024 2,767 kg/dm3', value: '2.767' },
          { name: 'EN AW-2014 2,799 kg/dm3', value: '2.799' },
          { name: 'EN AW-5754 2,659 kg/dm3', value: '2.659' },
          { name: 'EN AW-5005A 2,689 kg/dm3', value: '2.689' },
          { name: '2,8 kg/dm3', value: '2.8' },
          { name: '2,9 kg/dm3', value: '2.9' },
        ],
        [{ name: '7,85 kg/dm3', value: '7.85' },
          { name: '7,5 kg/dm3', value: '7.5' },
          { name: '7,7 kg/dm3', value: '7.7' },
          { name: '7,8 kg/dm3', value: '7.8' },
          { name: '7,9 kg/dm3', value: '7.9' },
          { name: '8,0 kg/dm3', value: '8' },
          { name: '8,1 kg/dm3', value: '8.1' },
        ],
        [{ name: '8.9kg/dm3', value: '8.9' }],
        [{ name: '7.8kg/dm3', value: '7.8' }],
        [{ name: '11.68kg/dm3', value: '11.68' }],
        [{ name: '9.9kg/dm3', value: '9.9' }],
        [{ name: '7.2kg/dm3', value: '7.2' }],
        [{ name: '6.7kg/dm3', value: '6.7' }],
        [{ name: '19.3kg/dm3', value: '19.3' }],
      ],
      meta: '',
      densityChoose: '',
    };
  },
  methods: {
    denistyValue(gestosc) {
        this.$emit('denisty', gestosc);
      },
    },
    beforeMount() {
      function compare(a, b) {
        if (a.value < b.value) { return -1; } else if (a.value > b.value) { return 1; }
        return 0;
      }
      return [
        this.densityArray[0].sort(compare),
        this.densityArray[3].sort(compare),
        this.densityArray[4].sort(compare),
      ];
    },
};
</script>

<style scoped>
  .select-place{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    margin-bottom: 5px;
  }
  .select-place select{
    flex: 1 1 49%;
    max-width: 49%;
    width: 100%;
    border:0;
    background: transparent;
    font-size: 0.8rem;
    text-align: left;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: '';
    padding: 5px;
    border: 1px solid #22252C;
    color: #22252C;
    
  }
  .select-place select option{
    color: var(--main-txt-color);
  }
</style>
